// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_ov-0";